import { AUDIT_PARTNER } from '@/constants/security';
import { cn } from '@/utils';
import { CheckCircle2, ExternalLink } from 'lucide-react';
import { Badge } from './ui/badge';

type MoveBitAuditBadgeProps = {
	className?: string;
	label?: string;
};

export function MoveBitAuditBadge({ className, label }: MoveBitAuditBadgeProps) {
	const auditLabel = label ?? AUDIT_PARTNER.label;

	return (
		<a
			href={AUDIT_PARTNER.url}
			target="_blank"
			rel="noreferrer"
			className={cn('inline-flex items-center no-underline', className)}
			aria-label={`${auditLabel}, opens MoveBit website in a new tab`}
		>
			<Badge
				variant="success"
				size="lg"
				className="gap-1.5 border-success/40 bg-success/20 shadow-sm hover:bg-success/20 text-muted-foreground transition-colors"
			>
				<CheckCircle2 className="h-4 w-4" aria-hidden />
				<span className="text-sm font-semibold">{auditLabel}</span>
				<ExternalLink className="h-3.5 w-3.5 opacity-80" aria-hidden />
			</Badge>
		</a>
	);
}
